import {Component, OnInit, inject} from '@angular/core';
import {UntilDestroy} from '@ngneat/until-destroy';
import {TranslationService} from '@spartacus/core';
import {
  Configurator,
  ConfiguratorAttributeCompositionContext,
  ConfiguratorAttributeDropDownComponent,
  ConfiguratorAttributeQuantityService,
  ConfiguratorCommonsService,
  ConfiguratorStorefrontUtilsService,
} from '@spartacus/product-configurator/rulebased';
import {ConfigService, FeatureTogglesService} from '../../services';
import {valueProviderTokens} from '../../token/tokens';
import {HasPendingChangesService} from '../disable-loading-form/has-pending-changes.service';

@UntilDestroy()
@Component({
  selector: 'dcp-configurator-attribute-drop-down',
  templateUrl: './dcp-configurator-attribute-dropdown.component.html',
  styleUrls: [],
  standalone: false,
})
export class DcpConfiguratorAttributeDropdownComponent
  extends ConfiguratorAttributeDropDownComponent
  implements OnInit
{
  private unleashToggles = inject(valueProviderTokens.FEATURE_TOGGLES);
  override attribute: Configurator.Attribute = this.attributeComponentContext.attribute;

  constructor(
    protected override quantityService: ConfiguratorAttributeQuantityService,
    public configService: ConfigService,
    public hasPendingChangesService: HasPendingChangesService,
    public featureTogglesService: FeatureTogglesService,
    translationService: TranslationService,
    configuratorAttributeCompositionContext: ConfiguratorAttributeCompositionContext,
    configuratorCommonsService: ConfiguratorCommonsService,
    configuratorStorefrontUtilsService: ConfiguratorStorefrontUtilsService,
  ) {
    super(
      quantityService,
      translationService,
      configuratorAttributeCompositionContext,
      configuratorCommonsService,
      configuratorStorefrontUtilsService,
    );
  }

  onSelectionChange(event: Event): void {
    const customEvent = event as CustomEvent;
    const value = customEvent.detail.item.value;
    this.onSelect(value);
  }

  override onSelect(value: string): void {
    if (value !== this.getSelectedValue()?.valueCode) {
      this.configuratorCommonsService.updateConfiguration(
        this.ownerKey,
        {
          ...this.attribute,
          selectedSingleValue: value,
        },
        Configurator.UpdateType.ATTRIBUTE,
      );
    }
  }

  getSupportingText(): string {
    const validation = this.attribute?.validation || [];
    if (validation?.length > 0) {
      const descriptionText = validation[0]?.descriptionText || validation[0]?.description;
      return descriptionText || '';
    }
    return '';
  }

  getValueState(): string {
    return this.getSupportingText() ? 'Error' : 'Standard';
  }

  // This logic would be changed after UDEx will provide solution which meets business requirements

  getParsedLabel(valueCode: string): string {
    const selected = this.getSelectedValue();
    if (selected?.valueCode === valueCode) {
      const htmlSnippet = selected.selectedHtml || selected.valueDisplay;
      const labels = htmlSnippet?.split(/<\/?br\s*\/?>/g) || [];
      return labels[0] || '';
    }
    return '';
  }

  getParsedSelectContractLabel(valueCode: string): string {
    const selected = this.getSelectedValue();
    return selected?.valueCode === valueCode ? selected.valueDisplay || '' : '';
  }

  getParsedHTMLSnippet(value?: Configurator.Value): string {
    const selected = this.getSelectedValue();
    if (selected?.valueCode === value?.valueCode) {
      return this.parseHTMLSnippet(selected?.valueDisplay);
    }
    return value?.valueDisplay || value?.selectedHtml || '';
  }

  getParsedSelectContractSnippet(value?: Configurator.Value): string {
    const selected = this.getSelectedValue();
    if (selected?.valueCode === value?.valueCode) {
      return this.parseHTMLSnippet(selected?.selectedHtml);
    }
    return value?.selectedHtml || '';
  }

  parseHTMLSnippet(value?: string): string {
    const snippets = value?.split(/<\/?br\s*\/?>/g) || [];
    const parsedSnippetArray = snippets.slice(1).join('</br>');
    return parsedSnippetArray || '';
  }

  parseDescription(value?: string): string {
    const snippets = value?.split('\n') || [];
    const parsedSnippetArray = snippets.join('</br>');
    return parsedSnippetArray || '';
  }

  isManageCloudAccessSection(type: string): boolean {
    return this.isSelectContract(type) || this.isGlobalAccounts(type) || this.isSystemSelection(type);
  }

  isSelectContract(type: string): boolean {
    return type === 'Select Contract';
  }

  isGlobalAccounts(type: string): boolean {
    return type === 'Global Accounts';
  }

  isSystemSelection(type: string): boolean {
    return type === 'System selection';
  }
}
